export const detailsPanelExpandedSelector = ({detailsPanelExpanded}) => detailsPanelExpanded